import { create } from "zustand";
import { CursorType } from "../globalSettingsSlice";

interface SupabaseConnectStore {
  connectedOrgId: string;
  connectedOrgName: string;
  connectedProjects: any[];
  connectedProjectId: string;

  loadingConnectionState: boolean;
  loadedConnectedState: boolean;
  setLoadingConnectionState: (loading: boolean) => void;
  setLoadedConnectedState: (loaded: boolean) => void;

  setConnectedOrg: (orgId: string, orgName: string, projects: any[]) => void;
  setConnectedProjectId: (projectId: string) => void;

  resetSupabaseConnectStore: () => void;
}

// Create the Zustand store with a more structured and type-safe approach
const useSupabaseConnectStore = create<SupabaseConnectStore>((set, get) => ({
  // @ts-expect-error TS2322
  connectedOrgId: null,
  // @ts-expect-error TS2322
  connectedOrgName: null,
  connectedProjects: [],
  // @ts-expect-error TS2322
  connectedProjectId: null,
  selectedProject: null,

  loadingConnectionState: false,
  loadedConnectedState: false,

  setLoadingConnectionState: (loading: boolean) =>
    set({
      loadingConnectionState: loading,
    }),
  setLoadedConnectedState: (loaded: boolean) =>
    set({
      loadedConnectedState: loaded,
    }),

  setConnectedOrg: (orgId: string, orgName: string, projects: any[]) =>
    set({
      connectedOrgId: orgId,
      connectedOrgName: orgName,
      connectedProjects: projects,
    }),
  setConnectedProjectId: (projectId: string) =>
    set({
      connectedProjectId: projectId,
    }),

  resetSupabaseConnectStore: () =>
    set({
      // @ts-expect-error TS2322
      connectedOrgId: null,
      // @ts-expect-error TS2322
      connectedOrgName: null,
      connectedProjects: [],
      // @ts-expect-error TS2322
      connectedProjectId: null,
      loadingConnectionState: false,
      loadedConnectedState: false,
    }),
}));

export default useSupabaseConnectStore;
